import { subMonths } from "date-fns"

import { api } from "~/utils/api"
import { startOfTodayUTC } from "~/utils/datetime"
import { dateSeries } from "~/utils/graphUtils"
import { useChartSeriesConfig } from "~/constants/colors"

import SuperChart from "./SuperChart"
import { ChartType } from "~/constants/graphs"

type Props = {
  variantIds: string[]
  /** Optional narrowing to specific SKUs of the given variants (SKU leaf rows). */
  skuIds?: string[]
}

export default function InventoryValueGraph({ variantIds, skuIds }: Props) {
  const chartConfig = useChartSeriesConfig()
  const { data: inventoryData } = api.product.inventoryValuesLastYear.useQuery(
    { variantIds, skuIds },
    { enabled: variantIds.length > 0 },
  )

  if (!inventoryData) {
    return <div className="p-4">Loading inventory values</div>
  }

  // Inventory value is closing stock priced at cost, so it shares that term's color.
  const inventoryValueSeries = dateSeries(chartConfig.closingStock, {
    name: "Inventory value",
    data: inventoryData.map(({ date, value }) => ({
      milliseconds: date.getTime(),
      value: Math.round(value),
    })),
    type: "areaspline",
  })

  return (
    <SuperChart
      height={300}
      type={ChartType.TimeSeries}
      data={[inventoryValueSeries]}
      noLegend
      dateRange={{
        start: subMonths(startOfTodayUTC(), 12),
        end: startOfTodayUTC(),
      }}
      disableAnimation
    />
  )
}
